const USE_PROD_ENDPOINTS = false // Single switch for prod endpoint usage.

const hasWindow = () => typeof window !== 'undefined'

const hasLocalStorageProdOverride = () => {
    if (!hasWindow()) return false

    try {
        return Boolean(window.localStorage.getItem('envp'))
    } catch (error) {
        return false
    }
}

export const isProdEnvironment = () => {
    if (USE_PROD_ENDPOINTS) return true
    if (!hasWindow()) return false

    return Boolean(
        window.isPROD ||
            window.location.host.indexOf('mybusiness') >= 0 ||
            hasLocalStorageProdOverride()
    )
}

export const toEnvironmentUrl = url => {
    if (typeof url !== 'string') return url
    return isProdEnvironment() ? url.replace('uat', '') : url
}

export const toDemoEnvironmentUrl = url => {
    if (typeof url !== 'string') return url
    return url.replace('env', isProdEnvironment() ? 'prod' : 'uat')
}

export const getRegisterUrl = isNz =>
    isNz
        ? 'https://www.canon.co.nz/business/register'
        : toEnvironmentUrl('https://uatsolutions.canon.com.au/register')

if (hasWindow()) {
    window.isPROD = isProdEnvironment()
}
